import { render, staticRenderFns } from "./InlineAlertFooterLink.vue?vue&type=template&id=fb9118d6&scoped=true"
import script from "./InlineAlertFooterLink.vue?vue&type=script&lang=js"
export * from "./InlineAlertFooterLink.vue?vue&type=script&lang=js"
import style0 from "./InlineAlertFooterLink.vue?vue&type=style&index=0&id=fb9118d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9118d6",
  null
  
)

export default component.exports